// extracted by mini-css-extract-plugin
module.exports = {"row":"ImportResultUserApartment_row_3TLfq","toggle":"ImportResultUserApartment_toggle_x1DCL","list":"ImportResultUserApartment_list_3JnKb"};